import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility,grid } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { EventManager } from '../../utilities/events';
import { ContextProvider } from '@lit/context';
import { locationListingsContext} from '../../utilities/context';
import { arrowBack } from '../../utilities/icons';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInListingsLocations extends LitElement {
    static properties = {
        action: { type: String },
        perpage: { type: Number },
        params: { type: Object },
        _search: { type: String },
        _addressSearch: { type: String },
        _personalisation: { type: Object },
        _accessibility: { type: Array },
        _format: { type: String },
        _page: { type: Number },
        _type: { type: Array },
        _currentLocation: { state: true, type: String },
    }

    constructor() {
        super();
    }

    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this.eventManager.listen('allin-location-listings-show-panel', this._showPanel.bind(this));
        this.context = {
            
        };
        this._organisationData = new ContextProvider(this, {context:locationListingsContext,initial:this.context});
        if(this.params){
            this._search = this.params.search??'';
            this._addressSearch = this.params.addressSearch??'';
            this._personalisation = this.params.personalisation??{};
            this._accessibility = this.params.accessibility??[];
            this._type = this.params.type??[];
            this._format = this.params.format??'';
            this._page = this.params.page??1;
            this._currentLocation = this.params.currentLocation??'';
        }
        cardLinks(this.shadowRoot);
    }
    
    disconnectedCallback(){
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    updated(changedProperties){
        if(changedProperties.has('panel')||changedProperties.has('view')){
            this.renderRoot.querySelector('button,a')?.focus();
        }
        cardLinks(this.shadowRoot);

    }

    _setDocumentTitle(title){
        document.title = `${title} - All In`;
    }

    render() {
        let main;
        if(this._currentLocation){
           main=html`
            <allin-location
                location="${this._currentLocation}"
                remoteUrl="${this.action}/location/"
            >
            </allin-location>
           `;
        }
        else{
            main=html`
                <allin-listings-locations></allin-listings-locations>
            `;
        }
        return html`${main}`;
    }

    _showPanel(panel,view){
        this.panel = panel;
        let name = '';
        if(this.panel=='new'){
            name = 'New Location';
            
        }
        else{
            let loc = this._getLocationById(this.panel);
            if(loc){
                name = loc.name;
            }
            else{
                name = 'Location';
            }

        }
        if(view){
            panel+='/view';
            name = 'View Location';
        }
        this._setDocumentTitle(name?name:'Locations')
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,{crumb:{url:`/organisation-dashboard/${this.currentOrg}/locations/${panel}`,title:name}});
        this.eventManager.addHistory('/organisation-dashboard/'+this.currentOrg+'/locations/'+panel,{panel:this.panel});
    }

    _hidePanel(){
        this.panel = '';
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,{back:1});
        this.eventManager.addHistory('/organisation-dashboard/'+this.currentOrg+'/settings',{panel:''});
        this.partial = false;
    }

    _handleContextUpdate(value){
        this.organisationData = value;
        let prevPanel = this.panel;
        ({currentOrg:this.currentOrg,name:this.name,panel:this.panel,view:this.view,restUrl:this.restUrl,nonce:this.nonce,action:this.action} = this.organisationData);
        if(this.panel&&this.panel!=prevPanel){
            this._showPanel(this.panel,this.view);
        }
    }

    _getLocationById(id){
        let lId = this.organisation?.locations?.find((loc)=>loc.id==id);
        return lId;
    }

    _getOrganisationById(id){
        return this.organisations.find((org)=>org.org_id==id);
    }
    
    async _fetchLocations(){
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-locations&nonce=${this.nonce}`;
        try{
            let response = await fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Public': 'public',
                }
            })

            //show logged out modal if session has expired
            if(response.status === 403){
                handle403s();
                return;
            }

            let data = await response.json();
            this.organisation.locations = data.locations;
            this.eventManager.emit(`allin-organisation-${this.name}-update`,{organisation:JSON.stringify(this.organisation)});
        }
        catch(error){
            console.error('Error:', error);
        };
    } 

    static styles = [
        accessibility,
        grid,
        css`
        
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }

        .grid{
            gap:1.5rem;
        }
        
        .card a{
            display:block;
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            background-color:var(--allin-highlight-color,#472961);
            color:#fff;
            text-align:center;
            font-weight:700;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            height:fit-content;
            align-self:end;
        }

        .card:hover a{
            background-color:var(--allin-highlight-color-lighter,#5e3e7d);
        }


        h3,p{
            margin:0;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }

        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button, .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {
            .button-group button svg, .return svg{
                transform: none !important;
            }
        }
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child{
            width:40%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:60%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }
        ul{
            list-style:none;
            padding:0;
            margin:0;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }

        `
        ];
}